module.exports = __webpack_public_path__ + "img/five-bessings-cart.f56b7313.png";